import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import App from '@/App';
import { initAnalytics } from '@/lib/analytics';
import { initErrorMonitoring, ErrorBoundary } from '@/lib/errorMonitoring';

// No-op unless VITE_SENTRY_DSN is set.
initErrorMonitoring();

// No-op unless VITE_POSTHOG_KEY is set.
initAnalytics();

// PWA shell (M3.4): production only, so dev never serves a stale bundle.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => { /* optional */ });
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
    <ErrorBoundary fallback={<div style={{ padding: 32, fontFamily: 'sans-serif' }}><h2>Something went wrong.</h2><p>Reload the page. If it keeps happening, email support@cinerian.com.</p></div>}>
      <App />
    </ErrorBoundary>
  // </React.StrictMode>
);
